import React from 'react';

import './AddressSection.css';
import AutoSearchInput from '../AutoSearchInput';
import HoveredDropDown from '../HoveredDropDown';
import InputField from '../InputField';
import { getNationalityOptions } from '../../../../constants/Countries';
import { checkValidation, validations } from '../../../../constants/Validators';

export default (props) => {

  const onSelected = (field) => (item) => props.changeUserData(field, item);

  const changeValue = (field) => (value) => props.changeUserData(field, value);

  const changePinCode = (pinCode) => props.getDetailsFromPinCode(pinCode);

  const { title, residentialAddress, pinCode, showError, pinCodeErrorMessage, mobileNumber,
    cityList, postOfficeList, stateList, city, postOffice, regionalState, country } = props;
  return (
    <div className="appendBottom40 addressSection">
      <p className="latoBlack font22 appendBottom20 blacktext">
        {title}
      </p>
      <div className="formDataContainer">
        <div className="makeFlex flexWrap">
          <InputField
            value={residentialAddress}
            label="Enter your residential address"
            maxLength={200}
            error={showError && !residentialAddress}
            type={'text'}
            errorMsg={'Enter a valid address'}
            className="residentialField"
            changeValue={changeValue('residentialAddress')}
          />
          <InputField
            value={mobileNumber}
            label="Enter your mobile number"
            maxLength={10}
            error={showError && !checkValidation(mobileNumber, validations.mobileNumber)}
            type={'number'}
            errorMsg={'Enter a valid mobile number'}
            prefixCode={'+91'}
            changeValue={changeValue('residentialMobileNumber')}
          />
        </div>
        <div className="makeFlex flexWrap">
          <InputField
            value={pinCode}
            label="Enter pin code"
            maxLength={6}
            className="pinCode"
            error={!!pinCodeErrorMessage || (showError && !checkValidation(pinCode, validations.pinCode))}
            errorMsg={pinCodeErrorMessage || 'Enter a valid pin code'}
            changeValue={changePinCode}
          />
          {
            cityList && !pinCodeErrorMessage &&
              < HoveredDropDown
                classNames={'inputFieldContainer'}
                data={cityList}
                defaultSelected={city}
                labelName="Select your city"
                onSelected={onSelected('city')}
              />
          }
          {
            postOfficeList && !pinCodeErrorMessage &&
            < HoveredDropDown
              classNames={'inputFieldContainer'}
              data={postOfficeList}
              defaultSelected={postOffice}
              labelName="Select your postOffice"
              onSelected={onSelected('postOffice')}
            />
          }
          {
            stateList && !pinCodeErrorMessage &&
            < HoveredDropDown
              classNames={'inputFieldContainer'}
              data={stateList}
              defaultSelected={regionalState}
              labelName="Select your state"
              onSelected={onSelected('regionalState')}
            />
          }
        </div>
        <div className="makeFlex column">
          <AutoSearchInput
            label={'Select your country of residence'}
            className="autoSearchField"
            data={getNationalityOptions()}
            defaultSelected={country}
            onSelected={onSelected('country')}
          />
          <p className='font13 foreignNationalWarning'>Foreign nationals can register through IRCTC website only</p>
        </div>
      </div>
    </div>
  );
};
